import { AnimatePresence, motion } from "framer-motion";
import { formatPrice } from "@/utils/ShopifyHelpers";
import { Progress } from "@/components/ui/progress";

type FreeShippingBannerProps = {
  hasFreeShipping: boolean;
  shippingRemaining: number;
  currencyCode: string;
  shippingProgress: number;
};

export default function FreeShippingBanner({
  hasFreeShipping,
  shippingRemaining,
  currencyCode,
  shippingProgress,
}: FreeShippingBannerProps) {
  return (
    <AnimatePresence initial={false}>
      {!hasFreeShipping && (
        <motion.div
          initial={{ height: 0, opacity: 0, marginTop: 0 }}
          animate={{ height: "auto", opacity: 1, marginTop: 16 }}
          exit={{ height: 0, opacity: 0, marginTop: 0 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          className="overflow-hidden"
        >
          <div className="flex flex-col rounded-lg border border-[#dbdbdb] bg-[#f5f3ef] p-4">
            <p className="font-trimMono text-[10px] uppercase leading-[1.5] tracking-[0.3px] text-[#54524e] md:leading-[1]">
              {`ADD ${formatPrice(shippingRemaining, currencyCode)} TO CART FOR FREE SHIPPING! `}
              <br className="md:hidden" />
              (CONTIGUOUS U.S. ONLY)
            </p>
            <div className="mt-2 overflow-hidden">
              <Progress value={shippingProgress} className="h-[7px] bg-white" />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
